











































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class MQTTIntegration extends Vue {
  @Prop() private integrationDetails!: any;
  private currentTopic: string = '';
  private availableFields: string[] = ['$deviceId', '$deviceType', '$location', '$site', '$siteId', '$projectId', '$organisationSlug', '$locationId', '$networkId', '$equipmentType'];
  private topicLevels: string[] = [];
  private readonly rules: any = {
    required: (value: string) => !!value || 'This field is required.',
  };
  private hidePassword: boolean = true;

  private get topicLevelRules() {
    const rules: any[] = [];
    rules.push(
        (v: string) => {
          if (v && v.length && v.startsWith('$') && !this.availableFields.find((el) => el === v)) {
            return `Topic level defined by user cannot start with '$'`;
          }
          return true;

        }, (v: string) => {
          if (v && v.length && /\s/.test(v)) {
            return `Topic level cannot contain empty spaces`;
          }
          return true;
        },
    );
    return rules;
  }

  private get qos(): number {
    return this.integrationDetails.qos !== undefined && this.integrationDetails.qos !== null
        ? this.integrationDetails.qos
        : 1;
  }

  private extractTopicLevels() {
    if (this.integrationDetails.topic && this.integrationDetails.topic.length > 0) {
      this.topicLevels = this.integrationDetails.topic.split('/');
    }
  }

  private constructTopic() {
    const levels = this.topicLevels.filter((t: string) => !!t && t.length > 0);
    // this.integrationDetails.topic = levels.join('/');
    this.$emit('update:detail', {key: 'topic', value: levels.join('/')});
  }

  private isValid(): boolean {
    return !!this.integrationDetails.endpoint && !!this.integrationDetails.topic;
  }

  @Watch('integrationDetails', { deep: true, immediate: true })
  private handleIsValidChanged() {
    this.extractTopicLevels();
    this.$emit('validate', this.isValid());
  }
}
